import Styled from 'styled-components'

export const StyledPropertyList = Styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
    width: 100%;
`
